export default __webpack_public_path__ + "static/media/S_Sapo.1eeeb28d.mp3";